import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function riwayatPekerjaan(RIWAYAT_PEKERJAAN_ID: number) {
  const res = await ApiClient.get(
    `/Pekerjaan?RIWAYAT_PEKERJAAN_ID=${RIWAYAT_PEKERJAAN_ID}`
  );
  return res.data[0];
}

export const useFetchRiwayatPekerjaan = mutationWrapper(riwayatPekerjaan);
